export default __webpack_public_path__ + "static/media/bike.eb1364e2.svg";